module.exports = "<p>\n  home works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home.component.html
// module id = ./src/app/components/home/home.component.html
// module chunks = main